import React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

// import { useAppDispatch } from 'shared/utils/hooks';
// import { openPopup } from 'shared/features/popups';
// import { PopupType } from 'shared/types/popups';

import styles from './styles.css';
import { IStaticElement } from '../../../types/calculator';

export const ProgramFeaturesButton: React.FC<IStaticElement> = props => {
  const { label: text } = props;

  // const dispatch = useAppDispatch();

  const handleClick = () => {
    // TODO: перенести логику попапа
    // dispatch(
    //   openPopup({
    //     type: PopupType.Programs,
    //     data: null,
    //   }),
    // );
  };

  return (
    <button className={styles.root} type="button" onClick={handleClick} data-testid="form-feature-button">
      <UIHeading4 color="text-main-default">{text}</UIHeading4>
      <IconFunctionalInformationCircle16 color="icon-main-default" />
    </button>
  );
};

ProgramFeaturesButton.displayName = 'ProgramFeaturesButton';
